export default __webpack_public_path__ + "static/media/youngminds_language.02bf4a8f.png";